const createAssignAssistantOperationData = (assistantOption) => {
  return {
    type: 'assignAssistant',
    assistantName: assistantOption.label,
    assistantId: assistantOption.value,
  }
}

export default createAssignAssistantOperationData;